import React from 'react';

// Pixel-clean, brand-accurate SVG logos rendered on white card backgrounds

export const VisaLogo = ({ className = '' }) => (
  <svg viewBox="0 0 78 24" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Visa">
    <path d="M32.3 23.6H26L30 .7h6.3l-4 22.9z" fill="#1A1F71"/>
    <path d="M56.2 1.2c-1.2-.5-3.2-1-5.6-1-6.2 0-10.6 3.2-10.6 7.8 0 3.4 3.1 5.3 5.5 6.4 2.4 1.1 3.2 1.8 3.2 2.8-.0 1.5-1.8 2.2-3.5 2.2-2.3 0-3.6-.3-5.5-1.2l-.8-.4-.8 4.9c1.4.6 3.9 1.2 6.6 1.2 6.6 0 10.9-3.2 10.9-8.1 0-2.7-1.6-4.7-5.2-6.4-2.2-1.1-3.5-1.8-3.5-2.9 0-1 1.1-2 3.5-2 2 0 3.5.4 4.6.9l.6.3.8-4.5z" fill="#1A1F71"/>
    <path d="M69.2.7h-4.9c-1.5 0-2.6.4-3.3 2l-9.4 20.9h6.6s1.1-2.9 1.3-3.5c.7 0 7.2 0 8.1 0 .2.8.7 3.5.7 3.5H74L69.2.7zM61.6 15.6c.5-1.4 2.5-6.5 2.5-6.5 0 .1.5-1.4.8-2.3l.4 2.1s1.2 5.6 1.5 6.7h-5.2z" fill="#1A1F71"/>
    <path d="M22 .7L15.7 16.3 15 12.9c-1.2-3.9-4.7-8.1-8.7-10.2l5.8 20.9h6.7L28.7.7H22z" fill="#1A1F71"/>
    <path d="M9.9.7H.1L0 1.2c7.6 1.9 12.6 6.5 14.7 12l-2.1-10.5c-.4-1.5-1.4-2-2.7-2z" fill="#F7B600"/>
  </svg>
);

export const MastercardLogo = ({ className = '' }) => (
  <svg viewBox="0 0 48 30" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="Mastercard">
    <circle cx="17" cy="15" r="12" fill="#EB001B"/>
    <circle cx="31" cy="15" r="12" fill="#F79E1B"/>
    <path d="M24 5.4a12 12 0 010 19.2 12 12 0 010-19.2z" fill="#FF5F00"/>
  </svg>
);

export const AmexLogo = ({ className = '' }) => (
  <svg viewBox="0 0 80 24" xmlns="http://www.w3.org/2000/svg" className={className} aria-label="American Express">
    <rect width="80" height="24" rx="2" fill="#1F72CD"/>
    <text x="40" y="10" textAnchor="middle" fill="#fff" fontFamily="'Helvetica Neue', Arial, sans-serif" fontWeight="700" fontSize="5" letterSpacing="0.5">AMERICAN</text>
    <text x="40" y="17" textAnchor="middle" fill="#fff" fontFamily="'Helvetica Neue', Arial, sans-serif" fontWeight="700" fontSize="5" letterSpacing="0.5">EXPRESS</text>
    <path d="M8 20l1-2h4l1 2M66 20l1-2h4l1 2" stroke="#fff" strokeWidth="0.5" fill="none" opacity="0.6"/>
  </svg>
);
